var objectToString = Object.prototype.toString

module.exports = objectToString
